import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../http/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminAuthGuard implements CanActivate {
  constructor(private authService: AuthService,
    private router: Router) { 
     }

  canActivate() {
    let token = localStorage.getItem('token');
    if (!token){
        this.router.navigate(['login']);
        return false;
    }
    if (!this.authService.isLoggedIn() || !this.authService.isAdmin()) 
    {
      this.router.navigate(['login']);
      return false;
    }
     return true;
  }
}
